<template>
    <div class="app-toast is--error" role="alert">
        <div class="app-toast__text">
            <p class="app-toast__title">{{ message }}</p>
            <ul v-for="(data, key) in _errors" :key="`error-${key}`">
                <li v-for="(message, index) in data" :key="`error-${key}-${index}`">
                    {{ message }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String
        },
        errors: {
            type: Object,
            default: () => ({ })
        }
    },
    computed: {
        _errors() {
            return this.errors?.errors || (_.isArray(this.errors)) ? this.errors : (this.errors?.message ? [this.errors] : this.errors)
        }
    },
}
</script>
